import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import { omit } from 'lodash'
import { useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

const LinkToCustomerService = ({ children, linkProps }) => {
    const { i18n } = useTranslation()

    return <Link to={`${getLocale(i18n.language)}/ota-yhteytta`} trackName="customerService" {...linkProps}>{children}</Link>
}

LinkToCustomerService.propTypes = {
    children: PropTypes.any.isRequired,
    linkProps: PropTypes.shape(omit(Link.propTypes, ['to', 'trackName'])),
}

export default LinkToCustomerService
